import {Injectable, signal} from '@angular/core';
import {
  DailyFeedbackReportsAggregationData
} from "../types/daily-feedback-reports-page.types";

@Injectable({
  providedIn: 'root'
})
export class DailyFeedbackReportsAggregationDataService {
  private _dailyFeedbackReportsAggregationData = signal<DailyFeedbackReportsAggregationData | null>(null);
  public dailyFeedbackReportsAggregationData = this._dailyFeedbackReportsAggregationData.asReadonly();

  public setDailyFeedbackReportsPagination(data: DailyFeedbackReportsAggregationData | null): void {
    this._dailyFeedbackReportsAggregationData.set(data);
  }
}
